export default {"src":"/_next/static/media/white-linkedin-icon.2a3e9236.svg","height":47,"width":46};